import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "utils/api";

// estimation quotation
export const updateEstimatioQuotation = createAsyncThunk(
  'estimation-quotation-settings',
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.post(`/exiprysetting`, bodyParams);
      return response
    }
    catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  })
